module.exports = __webpack_public_path__ + "img/BatAgriToitG.1ee90b05.png";